import React from 'react';

import {Typography} from 'antd';

import {truncate as truncateEmail} from 'lib/utils';

const {Text} = Typography;

type Props = {email?: string | null; children?: React.ReactNode; truncate?: boolean};

export const EmailLink: React.FC<Props> = ({email, children, truncate}) => {
  if (!email) return <Text type="secondary">No email provided</Text>;
  return (
    <a href={`mailto:${email}`}>{children || (truncate ? truncateEmail(email, 25) : email)}</a>
  );
};
